import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isDefined } from 'shared/domain/role/isDefined';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { isStandard } from 'shared/domain/role/isStandard';
import { isViewer } from 'shared/domain/role/isViewer';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoTemplateList } from 'views/template/list';
import { MemoTemplateWizard } from 'views/template/wizard';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';
export const AuthorizableTemplate = React.memo((): React.ReactElement => {
  const role = useCurrentUserRole();

  const isCurrentUserAuthorized = isDefined(role) && !isStandard(role);
  return (
    <MemoGenericRoleAuthorizer
      authorized={isCurrentUserAuthorized}
      unauthorized={isStandard(role)}
      authorizedComponent={MemoTemplateList}
      unauthorizedComponent={InsufficientPermissionsPage}
    />
  );
});

export const AuthorizableTemplateWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isManagerOrAdmin(role)}
        unauthorized={isCurrentUserStandardOrViewer}
        authorizedComponent={MemoTemplateWizard}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
